import { Link } from 'react-router-dom';

interface ProfileLinkProps {
    userId: number;
    displayName: string;
    className?: string;
}

export function ProfileLink({ userId, displayName, className }: ProfileLinkProps) {
    return (
        <Link
            to={`/profiles/${userId}`}
            className={className ?? 'text-violet-400 hover:underline'}
            onClick={(e) => e.stopPropagation()}
        >
            {displayName}
        </Link>
    );
}
